import { ThemeConfig } from "@chakra-ui/react"

export default <ThemeConfig>{
  initialColorMode: "light",
  useSystemColorMode: false,
}
